<ng-template [ngIf]="pageOptions.renderNavBar">
  <pvd-header hide-login="true"></pvd-header>
</ng-template>

<div class="pvd-container-fluid container-divider">
  <h1 class="pvd-heading-XXL" [innerHTML]="pageOptions.title"></h1>
</div>

<div id="breadcrumb-and-header-bar" *ngIf="onAnnuitiesPage">
  <ul class="breadcrumb">
    <li><a href="https://www.fidelity.com/">Home</a></li>
    <li>
      <a href="https://www.fidelity.com/research/annuities/overview.shtml"
        >Annuities</a
      >
    </li>
    <li>
      <a
        target="_blank"
        rel="noopener"
        [href]="
          'https://www.fidelity.com/products/funds/fili_frame.shtml?' +
          (prospectusInformation ? prospectusInformation.productCode : '')
        "
      >
        <span
          [innerHTML]="
            prospectusInformation ? prospectusInformation.productName : ' '
          "
        ></span>
      </a>
    </li>
  </ul>
</div>

<div class="pvd-container-fluid container-divider">
  <p [innerHTML]="pageOptions.description" class="description"></p>
  <p
    *ngIf="
      onAnnuitiesPage &&
      prospectusInformation &&
      prospectusInformation.productsDocuments
    "
  >
    <span *ngFor="let productDoc of productDocuments">
      <a
        [href]="getRedirect(productDoc.securityId, productDoc.documentType)"
        target="popup"
        (click)="
          openLinkInNewWindow(
            getRedirect(productDoc.securityId, productDoc.documentType)
          )
        "
      >
        <!-- <img src="../../images/play.jpg" [alt]="'Open document for ' + productDoc.key"> -->
        &#8227;&nbsp; <span [innerHTML]="productDoc.labelKey"></span>
      </a>
      <br />
    </span>
  </p>
  <pvd-system-message *ngIf="showFamilyAlert" placement="page" type="alert" dismissible="true" [message]="alertMessage"></pvd-system-message>
  <pvd-tabs  (pvd-tabs-tab-selected)="showTab($event)">
    <ng-container *ngFor="let tab of pageOptions.tabs; let index = index">
      <pvd-tab
        slot="tab"
        [selected]="pageOptions.selectedTab === index"
        [id]="index"
        [tab-id]="generateTabId(tab.id)"
        (keydown.enter)="changeTab(index)"
        [tabIndex]="0"
        [attr.pvd-aria-controls]="generateTabId(tab.id)"
        [attr.pvd-aria-label]="generateTabId(tab.id)"
        [attr.aria-controls]="generateTabId(tab.id)"
        [attr.aria-label]="generateTabId(tab.id)"
        [a11y-controls]="generatePanelId(tab.id)"
      >
        {{ tab.label }}
      </pvd-tab>
      <pvd-tab-panel
        role="tabpanel"
        slot="panel"
        [id]="generatePanelId(tab.id)"
        [tab-panel-id]="generatePanelId(tab.id)"
        aria-hidden="false"
      >
      <ng-template [ngTemplateOutlet]="TableGrid"></ng-template>
      </pvd-tab-panel>
    </ng-container>
  </pvd-tabs>
  <ng-container *ngIf="pageOptions.tabs && pageOptions.tabs.length === 0">
    <ng-template [ngTemplateOutlet]="TableGrid"></ng-template>
  </ng-container>
</div>

<div class="pvd-container" *ngIf="pageOptions.disclosures">
  <p
    class="xsmall color-neutral text-bold"
    [innerHTML]="pageOptions.disclosures"
  ></p>
  <p *ngIf="pageOptions.eReviewNumber" class="xsmall color-neutral">
    {{ pageOptions.eReviewNumber }}
  </p>
</div>

<ng-template #TableGrid >
  <div class="input-icon-inner search-field">
    <input
      [formControl]="searchControl"
      id="fund-search"
      type="text"
      class="pvd-input"
      aria-invalid="false"
      placeholder="Search for Fund"
    />
    <pvd-icon class="input-icon" icon="search"></pvd-icon>
  </div>

  <div class="table-container">
    <table class="pvd-table-simple table-striped">
      <thead>
        <tr>
          <th
            [ngClass]="isAscSort() ? 'sort-asc' : 'sort-desc'"
            (click)="toggleSort()"
          >
            Fund Name
          </th>
          <th class="text-left" *ngIf="isShownColumn('PROSPECTUS')">
            Prospectus
          </th>
          <th class="text-left" *ngIf="isShownColumn('SHARE_REPORTS')">
            Shareholder Reports
          </th>
          <th class="text-left" *ngIf="isShownColumn('SAI')">
            Statement of Additional Information (SAI)
          </th>
          <th class="text-left" *ngIf="isShownColumn('NPORT')">
            Quarterly Holdings Reports
          </th>
        </tr>
      </thead>

      <tbody>
        <tr
          *ngFor="
            let prospectus of filteredData | async;
            let i = index;
            trackBy: trackByFn
          "
        >
          <td
            class="table-row-header"
            [id]="getCusip(prospectus)"
            [innerHTML]="getFundName(prospectus)"
          ></td>

          <td *ngIf="isShownColumn('PROSPECTUS')">
            <div
              *ngIf="prospectus.documents && prospectus.documents.SUMS"
            >
              <a
                [href]="prospectus.documents.SUMS?.encUrlParam"
                target="popup"
                (click)="openCusipLinkPopup(prospectus.documents.SUMS?.encUrlParam)"
                >Summary
                <span class="date-subtext"
                  >({{
                    prospectus.documents.SUMS.effectiveDate?.slice(0, 10)
                  }})</span
                ></a
              >
            </div>
            <div
              *ngIf="prospectus.documents && prospectus.documents.PROS"
            >
              <a
                [href]="prospectus.documents.PROS?.encUrlParam"
                target="popup"
                (click)="openCusipLinkPopup(prospectus.documents.PROS?.encUrlParam)"
                >Full
                <span class="date-subtext"
                  >({{
                    prospectus.documents.PROS.effectiveDate?.slice(0, 10)
                  }})</span
                ></a
              >
            </div>
          </td>

          <td *ngIf="isShownColumn('SHARE_REPORTS')">
            <div *ngIf="prospectus.documents && prospectus.documents.TSRA;then tsra else ann"></div>
            <ng-template #tsra>
<div>
              <a
                [href]="prospectus.documents.TSRA?.encUrlParam"
                target="popup"
                (click)="openCusipLinkPopup(prospectus.documents.TSRA?.encUrlParam)"
                >Annual
                <span class="date-subtext"
                  >({{
                    prospectus.documents.TSRA.effectiveDate?.slice(0, 10)
                  }})</span
                ></a
              >
            </div>
            </ng-template>
            <ng-template #ann>
            <div *ngIf="prospectus.documents && prospectus.documents.ANN">
              <a
                [href]="prospectus.documents.ANN?.encUrlParam"
                target="popup"
                (click)="openCusipLinkPopup(prospectus.documents.ANN?.encUrlParam)"
                >Annual
                <span class="date-subtext"
                  >({{
                    prospectus.documents.ANN.effectiveDate?.slice(0, 10)
                  }})</span
                ></a
              >
            </div>
            </ng-template>

            <div *ngIf="prospectus.documents && prospectus.documents.TSRS;then tsrs else semi"></div>
            <ng-template #tsrs>
              <div>
              <a
                [href]="prospectus.documents.TSRS?.encUrlParam"
                target="popup"
                (click)="openCusipLinkPopup(prospectus.documents.TSRS?.encUrlParam)"
                >Semi-Annual
                <span class="date-subtext"
                  >({{
                    prospectus.documents.TSRS.effectiveDate?.slice(0, 10)
                  }})</span
                ></a
              >
            </div>
            </ng-template>
            <ng-template #semi>
            <div
              *ngIf="prospectus.documents && prospectus.documents.SEMI"
            >
              <a
                [href]="prospectus.documents.SEMI?.encUrlParam"
                target="popup"
                (click)="openCusipLinkPopup(prospectus.documents.SEMI?.encUrlParam)"
                >Semi-Annual
                <span class="date-subtext"
                  >({{
                    prospectus.documents.SEMI.effectiveDate?.slice(0, 10)
                  }})</span
                ></a
              >
            </div>
            </ng-template>
          </td>

          <td *ngIf="isShownColumn('SAI')">
            <div *ngIf="prospectus.documents && prospectus.documents.SAI">
              <a
                [href]="prospectus.documents.SAI?.encUrlParam"
                target="popup"
                (click)="openCusipLinkPopup(prospectus.documents.SAI?.encUrlParam)"
                >SAI
                <span class="date-subtext"
                  >({{
                    prospectus.documents.SAI.effectiveDate?.slice(0, 10)
                  }})</span
                ></a
              >
            </div>
          </td>

          <td *ngIf="isShownColumn('NPORT')">
            <div
              *ngIf="prospectus.documents && prospectus.documents.NPRT1"
            >
              <a
                [href]="prospectus.documents.NPRT1?.encUrlParam"
                target="popup"
                (click)="
                  openCusipLinkPopup(prospectus.documents.NPRT1?.encUrlParam)
                "
                >1st Quarter Holdings
                <span class="date-subtext"
                  >({{
                    prospectus.documents.NPRT1.effectiveDate?.slice(
                      0,
                      10
                    )
                  }})</span
                ></a
              >
            </div>
            <div
              *ngIf="prospectus.documents && prospectus.documents.PHQ1"
            >
              <a
                [href]="prospectus.documents.PHQ1?.encUrlParam"
                target="popup"
                (click)="openCusipLinkPopup(prospectus.documents.PHQ1?.encUrlParam)"
                >1st Quarter Holdings
                <span class="date-subtext"
                  >({{
                    prospectus.documents.PHQ1.effectiveDate?.slice(0, 10)
                  }})</span
                ></a
              >
            </div>
            <div
              *ngIf="prospectus.documents && prospectus.documents.NPRT3"
            >
              <a
                [href]="prospectus.documents.NPRT3?.encUrlParam"
                target="popup"
                (click)="
                  openCusipLinkPopup(prospectus.documents.NPRT3?.encUrlParam)
                "
                >3rd Quarter Holdings
                <span class="date-subtext"
                  >({{
                    prospectus.documents.NPRT3.effectiveDate?.slice(
                      0,
                      10
                    )
                  }})</span
                ></a
              >
            </div>
            <div
              *ngIf="prospectus.documents && prospectus.documents.PHQ3"
            >
              <a
                [href]="prospectus.documents.PHQ3?.encUrlParam"
                target="popup"
                (click)="openCusipLinkPopup(prospectus.documents.PHQ3?.encUrlParam)"
                >3rd Quarter Holdings
                <span class="date-subtext"
                  >({{
                    prospectus.documents.PHQ3.effectiveDate?.slice(0, 10)
                  }})</span
                ></a
              >
            </div>
          </td>
        </tr>

        <tr
          *ngIf="!loading && (filteredData | async)?.length == 0"
          style="text-align: center"
        >
          <td colspan="9">
            There are currently no prospectus to display.
          </td>
        </tr>

        <tr *ngIf="loading" style="text-align: center">
          <td colspan="9">Loading fund information...</td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>